// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");

function ReactUtils$S(Props) {
  return Props.children;
}

function ReactUtils$S$Opt(Props) {
  var children = Props.children;
  var $$default = Props.default;
  return Relude_Option.fold(null, (function (prim) {
                return prim;
              }), Curry._2(Relude_Option.Infix.$less$pipe$great, children, $$default));
}

var Opt = {
  make: ReactUtils$S$Opt
};

var S = {
  make: ReactUtils$S,
  Opt: Opt
};

function ReactUtils$I(Props) {
  var children = Props.children;
  return React.createElement(ReactUtils$S, {
              children: Relude_Int.toString(children)
            });
}

function ReactUtils$I$Opt(Props) {
  var children = Props.children;
  var $$default = Props.default;
  var tmp = {
    children: Relude_Option.map(Relude_Int.toString, children)
  };
  if ($$default !== undefined) {
    tmp.default = Caml_option.valFromOption($$default);
  }
  return React.createElement(ReactUtils$S$Opt, tmp);
}

var Opt$1 = {
  make: ReactUtils$I$Opt
};

var I = {
  make: ReactUtils$I,
  Opt: Opt$1
};

function ReactUtils$F(Props) {
  var children = Props.children;
  var formatNumber = Props.formatNumber;
  return React.createElement(ReactUtils$S, {
              children: Curry._1(Relude_Option.getOrElse(Relude_Float.toString, formatNumber), children)
            });
}

function ReactUtils$F$Opt(Props) {
  var children = Props.children;
  var $$default = Props.default;
  var formatNumber = Props.formatNumber;
  var tmp = {
    children: Relude_Option.map(Relude_Option.getOrElse(Relude_Float.toString, formatNumber), children)
  };
  if ($$default !== undefined) {
    tmp.default = Caml_option.valFromOption($$default);
  }
  return React.createElement(ReactUtils$S$Opt, tmp);
}

var Opt$2 = {
  make: ReactUtils$F$Opt
};

var F = {
  make: ReactUtils$F,
  Opt: Opt$2
};

function ReactUtils$A(Props) {
  return Props.children;
}

var A = {
  make: ReactUtils$A
};

function ReactUtils$L(Props) {
  var children = Props.children;
  return React.createElement(ReactUtils$A, {
              children: Relude_List.toArray(children)
            });
}

var L = {
  make: ReactUtils$L
};

function ReactUtils$WithTestId(Props) {
  var id = Props.id;
  var children = Props.children;
  return Relude_Option.fold(children, (function (id) {
                return React.cloneElement(children, {
                            "data-test-id": id
                          });
              }), id);
}

var WithTestId = {
  make: ReactUtils$WithTestId
};

exports.S = S;
exports.I = I;
exports.F = F;
exports.A = A;
exports.L = L;
exports.WithTestId = WithTestId;
/* react Not a pure module */
